import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Privacy = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
         <>
      <Helmet>
        <title>Privacy Policy - Yatri Interiors</title>
        <meta name="description" content="Crafting Interiors with Precision and Passion" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    
                    <div className="col-lg-12 col-12">
                        <div className="about-right">
                            <div className="text">
                                <h2>Privacy Policy</h2>
                                <p>This Privacy Policy applies to the website operated YATRI INTERIORS 
                                at We value your privacy and are committed to protecting your personal information.
                                This policy outlines how we collect, use, share, 
                                and safeguard your information when you interact with our website 
                                </p>
                                <h4>Information We Collect</h4>
                                <p><b>Personal Information</b></p>
                                <p>When you engage with our services, we may collect personal information such as:</p>
                               <ul>
                                    <li>Name</li>
                                    <li>Address</li>
                                    <li>Email address</li>
                                    <li>Phone number</li>
                                </ul> 
                            <p>This information is necessary to provide our services effectively, 
                            such as scheduling repairs, processing payments, and communicating service updates.</p>
                            <h4>Usage Information</h4>
                            <p><b>We may also collect non-personal data such as:</b></p>
                            <ul>
                                <li>	IP addresses</li>
<li>Browser type and version</li>
<li>Device information</li>
<li>Browsing behavior on our website</li>

                            </ul>
                                <p><b>This data is used to improve our website's functionality, enhance user experience, and analyze trends.</b></p>
                                <h4>How We Use Your Information</h4>
                                <p><b>Service Delivery</b></p>
                                <p>To provide and manage our services, including diagnosing appliance issues, coordinating appointments,
                                 and communicating service updates.</p>
                                 <p><b>Communication</b></p>
                                 <p>To respond to inquiries, offer customer support,
                                  and send relevant updates or promotional materials related to our services.</p>
                                  <p>
                                    <b>Service Improvement</b>
                                  </p>
                                  <p>To analyze collected data for improving service quality,
                                   resolving technical issues, and developing new features or offerings.</p>
                                   <h4>Information Sharing</h4>
                                   <ul>
                                    <li>We do not sell, trade, or lease your personal information to third parties.</li>
                                    <li>However, to ensure seamless service delivery, we may share necessary details with trusted service providers or technicians involved in fulfilling your requests.</li>
                                    <li>All third parties are contractually obligated to use your information solely for service-related purposes and to comply with applicable privacy laws.</li>
                                   </ul>
                                   <h4>Data Security</h4>
                                   <ul>
                                    <li>We employ appropriate technical and organizational measures to protect your information from unauthorized access, disclosure, alteration, or destruction.</li>
                                    <li>Our security practices adhere to industry standards, including encryption, secure servers, and regular system monitoring.</li>
                                   </ul>
                                   <h4>Cookies and Tracking Technologies</h4>
                                   <p>Our website may use cookies or similar technologies to:</p>
                                   <ul>
                                    <li>Enhance your browsing experience</li>
                                    <li>Analyze website traffic</li>
                                    <li>Understand user interactions</li>
                                   </ul>
                                   <p>You can manage your cookie preferences through your browser settings.</p>

                                   <h4>Third-Party Links</h4>
                                   <ul>
                                    <li>Our website may contain links to third-party websites or services.</li>
                                    <li>We are not responsible for the privacy practices or content of external sites. We encourage you to review the privacy policies of any third-party websites you visit.</li>

                                   </ul>
                            <h4>Your Rights</h4>
                            <p><b>You have the right to:</b></p>
                            <ul>
                                <li>
                                    Access your personal information
                                </li>
                                <li>
                                    Update or correct inaccuracies
                                </li>
                                <li>
                                    Request deletion of your data subject to legal and contractual obligations.
                                </li>
                            </ul>
                        <p><b>To exercise these rights, please contact us at the details provided below.</b></p>
                        <h4>Policy Updates</h4>
                        <ul>
                            <li>We may update this Privacy Policy to reflect changes in our practices, technology, or legal requirements.</li>
                            <li>Updates will be posted on this page, and the "Last Updated" date will be revised accordingly.</li>
                        </ul>
                        <h4>Contact Us</h4>
                        <p><b>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at: </b></p>
                        <p><b>Phone: 91 96632 22146  </b></p>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Privacy;